import { render, staticRenderFns } from "./BackgroundMenu.vue?vue&type=template&id=63697c74&scoped=true&lang=pug"
import script from "./BackgroundMenu.vue?vue&type=script&lang=ts"
export * from "./BackgroundMenu.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundMenu.vue?vue&type=style&index=0&id=63697c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63697c74",
  null
  
)

/* custom blocks */
import block0 from "./BackgroundMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports